module.exports = __webpack_public_path__ + "img/PD1505110802942787584.bba3619b.png";